import React from 'react'

export default class Practise extends React.Component {
  render() {
    return <div>Challenge</div>
  }
}
